<template>
  <jm-upload
    v-bind="$attrs"
    action="/newfib.php/index/api_base/uploadFile"
    :on-preview="download"
    v-on="$listeners"
    :on-success="uploadSuccess"
  >
    <slot />
  </jm-upload>
</template>

<script>
import jmUpload from './upload';

export default {
  name: 'JmAssetUpload',
  components: {
    jmUpload,
  },
  methods: {
    download(file) {
      this.$http.getFile({
        url: file.url,
        filename: file.name,
      });
    },
    uploadSuccess({ data, result }) {
      if (result === -1) {
        this.$message.error(data);
        return false;
      }
      data.name = data.filename;
      data.url = data.file_path;
      this.$emit('upload-success', data);
    }
  },
};
</script>
